var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg169(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3395 8.9355C7.58766 9.04947 7.88167 8.97602 8.04708 8.75875L8.25417 8.4875C8.4745 8.19373 8.82028 8.02083 9.1875 8.02083H10.9375C11.5814 8.02083 12.1042 8.5436 12.1042 9.1875V10.9375C12.1042 11.5814 11.5814 12.1042 10.9375 12.1042C5.13851 12.1042 0.4375 7.40316 0.4375 1.60417C0.4375 0.960266 0.960266 0.4375 1.60417 0.4375H3.35417C3.99807 0.4375 4.52083 0.960266 4.52083 1.60417V3.35417C4.52083 3.72138 4.34794 4.06717 4.05417 4.2875L3.78117 4.49225C3.56036 4.66085 3.48909 4.96178 3.61083 5.2115C4.40806 6.83075 5.71925 8.1403 7.3395 8.9355",
    stroke: "#1E191B",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg169);
export default __webpack_public_path__ + "static/media/svg169.5eba3d59be3604817ccd9ad823478b68.svg";
export { ForwardRef as ReactComponent };